<nb-form-field>
  <input
    type="text"
    nbInput
    fullWidth
    [placeholder]="placeholderKey | translate"
    [ngModel]="value"
    (ngModelChange)="onInput($event)"
  />
  <button nbSuffix nbButton ghost type="button">
    @if (value && value.length > 0) {
      <nb-icon icon="close-outline" (click)="clear()"></nb-icon>
    } @else {
      <nb-icon icon="search-outline" pack="eva"></nb-icon>
    }
  </button>
</nb-form-field>
